import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { FAQS } from "../../data/content";

export const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="max-w-[1400px] mx-auto px-5 md:px-12 py-24 md:py-32">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
        <div className="md:col-span-4">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#5AB82D]">
            Dudas frecuentes
          </span>
          <h2 className="mt-4 font-serif-display text-4xl sm:text-5xl font-medium tracking-tight text-[#0A1F10] leading-[1.05]">
            Preguntas frecuentes
          </h2>
          <p className="mt-5 text-base text-[#4B5E51] leading-relaxed">
            ¿Tienes otra duda? Escríbeme por WhatsApp y te respondo personalmente.
          </p>
        </div>
        <div className="md:col-span-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-b border-black/10">
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="text-left font-serif-display text-xl md:text-2xl font-semibold text-[#0A1F10] hover:text-[#5AB82D] hover:no-underline py-6"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-base text-[#4B5E51] leading-relaxed pb-6 max-w-2xl">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
